import React, { useEffect, useState } from 'react';
import i18next from 'i18next';
import { GroupingsService } from '../../services';
import PageTitle from '../PageTitle/page_title';
import AllChecklistReportForm from './all_checklist_report_form';
import AllChecklistReportResults from './all_checklist_report_results';

const AllChecklistReport = () => {
    const [errorMessage, setErrorMessage] = useState(null);
    const [availableGroupingValues, setAvailableGroupingValues] = useState(null);
    const [query, setQuery] = useState(null);

    useEffect(() => {
        GroupingsService.listAll()
            .then((response) => {
                const leafGroupings = response.groupings
                    .filter((grouping) => grouping.deviceGroup?.children?.length == 0)
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((grouping) => ({ value: grouping.id, label: grouping.name, grouping: grouping }));

                setAvailableGroupingValues(leafGroupings);
            })
            .catch((error) => {
                setErrorMessage("Error loading locations.");
                console.error(error);
            });
    }, []);

    if (availableGroupingValues) {
        return (
            <div>
                <div className="row">
                    <PageTitle title={i18next.t("pages.all-checklists-report.header")} />
                </div>
                {errorMessage && <div>{errorMessage}</div>}
                <div className="device-detail-report col-sm-12">
                    <AllChecklistReportForm groupingValues={availableGroupingValues} onSubmit={setQuery} />
                </div>
                <div className="device-detail-report col-sm-12">{query && <AllChecklistReportResults query={query} />}</div>
            </div>
        );
    } else {
        return <div className="loader">{i18next.t("loading")}</div>;
    }
};

export default AllChecklistReport;
